import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ProductDetail } from '../add-product/add-product.page';
import { AddProductSubformComponent } from '../../shared-components/add-product-subform/add-product-subform.component';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  SellerProductStore,
  Variant,
  VariantField,
  Variations,
} from 'src/app/stores/seller-product.store';
import { LoaderService } from 'src/app/services/loader.service';
import { Camera, CameraResultType } from '@capacitor/camera';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { imageUrl } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-variant',
  templateUrl: './add-variant.page.html',
  styleUrls: ['./add-variant.page.scss'],
})
export class AddVariantPage implements OnInit {
  @Input() varientData: Variant;
  @Input() oldType: boolean = false;
  readonly imageUrl = imageUrl;
  readonly ProductDetail = ProductDetail;
  variationType: number = null;
  variationForm: FormGroup;
  validation_errors: any;
  variations: Variations;
  selectedVariation: string;
  image: String = null;
  uploadedImage: string;
  size_type: string = null;
  variation_name: string = null;
  sizeTypes: string[] = [];
  addSize: boolean = false;
  sizeArray = ['XS', 'S', 'M', 'L', 'XL', 'XXL']
  showCustomField: boolean = false;
  customSize: string = '';
  constructor(
    private modalCtrl: ModalController,
    private FormBuilder: FormBuilder,
    private sellerProductStore: SellerProductStore,
    private loaderService: LoaderService,
    private translate: TranslateService,
    private authenticationStore: AuthenticationStore
  ) { }

  async ngOnInit() {
    this.uploadedImage = this.varientData ? this.varientData.img : '';
    this.customSize = ''
    if (this.varientData?.variation_fields?.length > 0) {
      this.varientData.variation_fields?.forEach((field) => {
        if (field.size_type) {
          this.addSize = true;
        }
      });
    }

    if (this.varientData?.variation_type == 2 && this.varientData?.variation_fields?.length > 0) {
      var filter = this.sizeArray?.filter(x => x === this.varientData?.variation_fields[0].size_type)
      if (filter?.length === 0) {
        this.showCustomField = true
        this.sizeArray?.push(this.varientData?.variation_fields[0]?.size_type)
      }
    }

    this.variationForm = this.FormBuilder.group({
      variation_fields: this.FormBuilder.array([]),
      isChecked: new FormControl(
        this.addSize ? this.addSize : false,
        Validators.compose([])
      ),
    });
    if (this.varientData.variation_fields?.length == 0) {
      this.addFields();
    } else {
      this.varientData.variation_fields?.forEach((field) => {
        this.addFields(field);
      });
    }

    this.getErrors();
    await this.getVariations();
    if (this.varientData?.variation_type || this.varientData?.variation_name) {
      this.variationType = this.varientData?.variation_type;
      this.variation_name = this.varientData?.variation_name;
      this.getVariationName();
    }
  }

  addFields(fieldOptions: VariantField = null) {
    const piece = this.FormBuilder.group({
      size_type: new FormControl(
        fieldOptions ? fieldOptions.size_type : '',
        Validators.compose([])
      ),
      variation_price: new FormControl(
        fieldOptions ? fieldOptions.variation_price : '',
        Validators.compose([Validators.required])
      ),
      inventory: new FormControl(
        fieldOptions ? fieldOptions.inventory : '',
        Validators.compose([Validators.required])
      ),
      sku: new FormControl(
        fieldOptions ? fieldOptions.sku : '',
        Validators.compose([])
      ),
      id: new FormControl(
        fieldOptions ? fieldOptions.id : '',
        Validators.compose([])
      ),
    });

    this.getProductFields.push(piece);
    if (fieldOptions && fieldOptions.size_type) {
      this.sizeTypes.push(fieldOptions.size_type);
    } else {
      this.sizeTypes.push(''); // Add an empty value for the new field
    }
  }

  get getProductFields() {
    return <FormArray>this.variationForm.get('variation_fields');
  }

  async addProductDetail(detailType: ProductDetail, index: number = 0) {
    const modal = await this.modalCtrl.create({
      component: AddProductSubformComponent,
      cssClass: 'add-varinat-size',
      backdropDismiss: true,
      componentProps: {
        productDetailType: detailType,
        variations: this.variations,
        size: this.sizeArray,
        variationType: this.variationType
      },
    });
    modal.present();

    const resp = await modal.onDidDismiss();
    if (resp.data) {
      if (resp?.role === 'size') {
        const selectedSize = resp.data;
        this.size_type = selectedSize;
        this.sizeTypes[index] = selectedSize; // Update the size type in the separate array
        this.getProductFields.at(index).patchValue({ size_type: selectedSize }); // Update the form control value
        if (this.variationType == 2) {
          this.customSize = resp.data
          this.showCustomField = false
          this.variation_name = this.customSize
        }
      } else if (resp?.role === "custom_size") {
        this.showCustomField = true
        // this.sizeArray.push(resp.data.size_name)
        // this.variation_name = resp.data.size_name
        // const selectedSize = resp.data.size_name;
        // this.size_type = selectedSize;
        // this.sizeTypes[index] = selectedSize;
        // this.getProductFields.at(index).patchValue({ size_type: selectedSize }); // Update the form control value
      } else {
        this.variationType = resp.data;
        await this.getVariations();
        this.getVariationName();
      }
    }
  }

  removeFormRow(index: number) {
    this.getProductFields.removeAt(index);
    this.sizeTypes.splice(index, 1);
  }
  getFieldSizeType(index: number): string {
    return this.sizeTypes[index];
  }

  handleName(event, name) {
    this.variation_name = event.target.value;
    if (name == 'customField') {
      this.customSize = event.target.value;
    }
  }

  getErrors() {
    this.validation_errors = {
      variation_name: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.REQUIRED_NAME`,
        },
        // { type: "minlength", message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.VARIATION_NAME_LENGTH` }
      ],
      variation_price: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.VARIATION_PRICE_REQUIRED`,
        },
      ],
      inventory: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.REQUIRED_INVENTORY`,
        },
      ],
      sku: [
        {
          type: 'required',
          message: `ADD_PRODUCT_SECTION.VARIATION.VARIATION_SUB_FORM.REQUIRED_SKU`,
        },
      ],
    };
  }

  getVariationName() {
    const variation = this.variations.data.filter(
      (variation) => variation.id == this.variationType
    );
    this.selectedVariation = variation[0].variation_name;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async saveVariation() {
    if (this.variationType == 2 && !this.uploadedImage) {
      this.saveVariationFunc();
    } else if (this.variationType == 1 && !this.uploadedImage) {
      this.loaderService.presentToast(
        this.translate.instant('PLACEHOLDER_TEXT.ADD_VARIANT_IMAGE_ERROR'),
        'middle',
        'danger',
        5000
      );
    } else {
      this.saveVariationFunc();
    }
  }

  saveVariationFunc() {
    this.variationForm.value.variation_type = this.variationType;
    this.variationForm.value.img = this.variationType == 1 ? this.uploadedImage : '';
    this.variationForm.value.variation_name = this.variation_name;
    this.variationForm.value.id = this.varientData?.id
      ? this.varientData?.id
      : '';
    // Perform validation for size_type field
    const variationFields = this.variationForm.get('variation_fields') as FormArray;
    var sizeTypes = variationFields.controls.map((control) => control.value.size_type);
    var allSizeTypesSelected = sizeTypes.every((size) => !!size);
    if (this.variationType == 2) {
      if (this.customSize == "") {
        if (!allSizeTypesSelected) {
          this.loaderService.presentToast(
            this.translate.instant('PLACEHOLDER_TEXT.SIZE_ERROR'),
            'middle',
            'danger',
            5000
          );
          return;
        }
      } else {
        allSizeTypesSelected = true
        variationFields.controls.map((control) => (control.value.size_type = this.customSize));
      }
    } else {
      if (this.addSize) {
        if (!allSizeTypesSelected) {
          this.loaderService.presentToast(
            this.translate.instant('PLACEHOLDER_TEXT.SIZE_ERROR'),
            'middle',
            'danger',
            5000
          );
          return;
        }
      } else {
        variationFields.controls.map((control) => (control.value.size_type = ''));
        this.variationForm.value.variation_fields.splice(1);
      }
    }
    if (this.variation_name == '' && this.variationType == 1) {
      this.loaderService.presentToast(
        this.translate.instant('PLACEHOLDER_TEXT.VARIATION_NAME_ERROR'),
        'middle',
        'danger',
        5000
      );
    } else {
      var variationData = {
        values: this.variationForm.value,
        variations: this.variations.data,
      };
      this.modalCtrl.dismiss(variationData);
    }
  }

  async getVariations() {
    this.loaderService.showLoading();
    this.variations = await this.sellerProductStore.getVariations();
    this.loaderService.dismissLoading();
  }

  async imageAction() {
    const image = await Camera.getPhoto({
      quality: 50,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
    });
    this.image = image.dataUrl;
    this.loaderService.showLoading();
    try {
      const imageUrl: any = await this.authenticationStore.imageUpload(
        image.dataUrl
      );
      this.loaderService.dismissLoading();
      this.uploadedImage = imageUrl.data.name;
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(
        error.error.data
          ? error.error.data
          : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'),
        'bottom',
        'danger'
      );
    }
  }

  selectSize(event) {
    this.addSize = event.detail.checked;
    if (!this.addSize) {
      this.variationForm.controls.variation_fields.value.splice(1);
      this.getProductFields.controls.splice(1);
    }
  }
}
